import { render, staticRenderFns } from "./TravelLocation.vue?vue&type=template&id=60a9e1a5&scoped=true&"
import script from "./TravelLocation.vue?vue&type=script&lang=js&"
export * from "./TravelLocation.vue?vue&type=script&lang=js&"
import style0 from "./TravelLocation.vue?vue&type=style&index=0&id=60a9e1a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a9e1a5",
  null
  
)

export default component.exports